import { render, staticRenderFns } from "./four_header.vue?vue&type=template&id=077086f8&scoped=true"
import script from "./four_header.vue?vue&type=script&lang=js"
export * from "./four_header.vue?vue&type=script&lang=js"
import style0 from "./four_header.vue?vue&type=style&index=0&id=077086f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077086f8",
  null
  
)

export default component.exports